import { render, staticRenderFns } from "./HistoryVoucher.vue?vue&type=template&id=685aaffe&scoped=true"
import script from "./HistoryVoucher.vue?vue&type=script&lang=js"
export * from "./HistoryVoucher.vue?vue&type=script&lang=js"
import style0 from "./HistoryVoucher.vue?vue&type=style&index=0&id=685aaffe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685aaffe",
  null
  
)

export default component.exports